export default __webpack_public_path__ + "static/media/light.2d8768fa.zip";